import AddIcon from "@mui/icons-material/Add";
import React from "react";

/** Dashed "+ Add …" button that appends a row to a list in an interaction preview. */
export default function PiAddLink(props: { text: string; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      className="inline-flex self-start items-center gap-1.5 h-[40px] px-3 rounded-[6px] border border-dashed border-interaction-primary-faded bg-transparent text-[14px] font-semibold text-interaction-primary cursor-pointer outline-none transition-colors hover:border-interaction-primary hover:bg-interaction-primary-washed focus-visible:border-interaction-primary"
    >
      <AddIcon sx={{ fontSize: 18 }} />
      {props.text}
    </button>
  );
}
